// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.edit-team__center__header {
    display: flex;
    margin-top: var(--space-x2-and-half);
    /* justify-content: space-between; */
}

.edit-team__center__header__content {
    display: flex;
    align-items: left;
}

.edit-team__center__content__tabs {
   display: flex;
   align-items: left;
   
}

.MuiTabs-root.edit-team__center__content__tabs {
    width: 100%;
}

.edit-team__tabpanel {
    width: 100%;
}

.edit-team-form__form {
    align-items: flex-start;
}

.edit-team__header{
    display: flex;
    justify-content: space-between;
    align-items: left;

    
}

.edit-team__header_header{
   justify-content: center;
   align-items: center;
   display: flex;
   
}

.edit-team__icon-close{
    background: var(--primary-light-color);
    color: var(--primary-dark-color);
    border-radius: 50%;
    font-size: var(--space-and-half);
    padding: var(--space-half);
    cursor: pointer;
}

.edit-team__container {
    display: flex;
    align-content: flex-start;
    flex-wrap: wrap;
    margin-top: var(--space-x2-and-half);
    justify-content: space-between;
    width: 100%;
    background-color: var(--white-color);
    box-shadow: 0px 1px 4px rgba(150, 150, 150, 0.25);        
    border-radius: var(--space);

}

.team__center-container.edit-team {
    /* grid-area: 1 / 4 / 1 / 12; */
    margin-bottom: var(--space-x2);
    margin-top: var(--space-x2);
    margin-left: var(--space-x2);
    margin-right: var(--space-x2);
}

.edit-team__tabpanel-line{
    border: none;
}`, "",{"version":3,"sources":["webpack://./src/app/leagues/components/league-edit-team/LeagueEditTeamComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,oCAAoC;IACpC,oCAAoC;AACxC;;AAEA;IACI,aAAa;IACb,iBAAiB;AACrB;;AAEA;GACG,aAAa;GACb,iBAAiB;;AAEpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,iBAAiB;;;AAGrB;;AAEA;GACG,uBAAuB;GACvB,mBAAmB;GACnB,aAAa;;AAEhB;;AAEA;IACI,sCAAsC;IACtC,gCAAgC;IAChC,kBAAkB;IAClB,gCAAgC;IAChC,0BAA0B;IAC1B,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,eAAe;IACf,oCAAoC;IACpC,8BAA8B;IAC9B,WAAW;IACX,oCAAoC;IACpC,iDAAiD;IACjD,2BAA2B;;AAE/B;;AAEA;IACI,+BAA+B;IAC/B,8BAA8B;IAC9B,2BAA2B;IAC3B,4BAA4B;IAC5B,6BAA6B;AACjC;;AAEA;IACI,YAAY;AAChB","sourcesContent":[".edit-team__center__header {\n    display: flex;\n    margin-top: var(--space-x2-and-half);\n    /* justify-content: space-between; */\n}\n\n.edit-team__center__header__content {\n    display: flex;\n    align-items: left;\n}\n\n.edit-team__center__content__tabs {\n   display: flex;\n   align-items: left;\n   \n}\n\n.MuiTabs-root.edit-team__center__content__tabs {\n    width: 100%;\n}\n\n.edit-team__tabpanel {\n    width: 100%;\n}\n\n.edit-team-form__form {\n    align-items: flex-start;\n}\n\n.edit-team__header{\n    display: flex;\n    justify-content: space-between;\n    align-items: left;\n\n    \n}\n\n.edit-team__header_header{\n   justify-content: center;\n   align-items: center;\n   display: flex;\n   \n}\n\n.edit-team__icon-close{\n    background: var(--primary-light-color);\n    color: var(--primary-dark-color);\n    border-radius: 50%;\n    font-size: var(--space-and-half);\n    padding: var(--space-half);\n    cursor: pointer;\n}\n\n.edit-team__container {\n    display: flex;\n    align-content: flex-start;\n    flex-wrap: wrap;\n    margin-top: var(--space-x2-and-half);\n    justify-content: space-between;\n    width: 100%;\n    background-color: var(--white-color);\n    box-shadow: 0px 1px 4px rgba(150, 150, 150, 0.25);        \n    border-radius: var(--space);\n\n}\n\n.team__center-container.edit-team {\n    /* grid-area: 1 / 4 / 1 / 12; */\n    margin-bottom: var(--space-x2);\n    margin-top: var(--space-x2);\n    margin-left: var(--space-x2);\n    margin-right: var(--space-x2);\n}\n\n.edit-team__tabpanel-line{\n    border: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
